import algoliasearch from "algoliasearch/lite"
import { useStaticQuery, graphql } from "gatsby"
import { createRef, default as React, useState } from "react"
import { InstantSearch } from "react-instantsearch-dom"
import { ThemeProvider } from "styled-components"
import StyledSearchBox from "./styled-search-box"
import StyledSearchResult from "./styled-search-result"
import StyledSearchRoot from "./styled-search-root"
import useClickOutside from "./use-click-outside"

const theme = {
  searchicon: "#1E87F0",
  foreground: "#150D30",
  titletext: "#150D30",
  headlinetext: "#666666",
  background: "#ffffdd", 
  faded: "#888",
}

export default function Search({ indices }) {

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            algolia {
              appID
              searchKey
            }
          }
	    	}
      }
    `
  )

  const algoliaAppID = site.siteMetadata.algolia.appID
  const algoliaSearchKey = site.siteMetadata.algolia.searchKey

  const rootRef = createRef()
  const [query, setQuery] = useState()
  const [hasFocus, setFocus] = useState(false)

  const algoliaClient = algoliasearch(
    algoliaAppID,
    algoliaSearchKey
  )
  
  const searchClient = {
    search(requests) {
      if (requests.every(({ params }) => !params.query)) {
        return Promise.resolve({
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            processingTimeMS: 0,
          })),
        });
      }
      return algoliaClient.search(requests);
    },
  };

  useClickOutside(rootRef, () => setFocus(false))
  return (
    <ThemeProvider theme={theme}>
      <StyledSearchRoot ref={rootRef}>
        <InstantSearch
          searchClient={searchClient}
          indexName={indices[0].name}
          onSearchStateChange={({ query }) => setQuery(query)}
        >
          <StyledSearchBox onFocus={() => setFocus(true)} hasFocus={hasFocus} />
          <StyledSearchResult
            show={query && query.length > 0 && hasFocus}
            indices={indices}
          />
        </InstantSearch>
      </StyledSearchRoot>
    </ThemeProvider>
  )
}